import { useDisclosure } from "@/hooks";
import { useUpdateRoom } from "@/hooks/query-hooks/useRoom";
import { Button } from "antd";
import { AiOutlineEdit } from "react-icons/ai";
import { RoomForm, RoomFormValues } from "./RoomForm";

export function EditRoom({ room }: { room: Room }) {
	const [open, { toggle }] = useDisclosure();

	const { mutate, isPending } = useUpdateRoom();

	const handleSubmit = (values: RoomFormValues) => {
		mutate(
			{ id: room.id, data: values },
			{
				onSuccess: () => {
					toggle();
				},
			},
		);
	};

	return (
		<>
			<Button
				icon={<AiOutlineEdit />}
				type="primary"
				onClick={toggle}
				title="Edit Room"
				className=" bg-primary-gradient rounded-lg!"
				size="large"
			>
				Edit
			</Button>
			<RoomForm
				open={open}
				onClose={toggle}
				onSubmit={handleSubmit}
				initialValues={room}
				loading={isPending}
			/>
		</>
	);
}
